import React from "react";
import ClipLoader from "react-spinners/ClipLoader";

export const ComponentLoader = () => {
    const styles = {
        // position: 'absolute',
        margin: "auto",
        left: "0",
        right: "0",
        top: "0",
        bottom: "0"
    };

    return (
        <div
            style={{
                position: "fixed",
                zIndex: 9999,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "100%",
                height: "100%",
                backgroundColor: "#817e8152",
                top: 0,
                bottom: 0,
                left: 0,
                right: 0,
                borderRadius: 30
            }}
        >
            <div>
                <ClipLoader
                    css={styles}
                    height={100}
                    width={20}
                    radius={100}
                    margin={30}
                    color={"#1a76d2"}
                    loading={true}
                />
            </div>
        </div>
    )
};
